const translations = {
  ADMINISTRATOR: 'ADMINISTRATOR',
  COMMON_OK: 'COMMON_OK',
  COMMON_GO_BACK: 'COMMON_GO_BACK',
  COMMON_CLOSE: 'COMMON_CLOSE',
  MAIN_LOGO_ALT_TEXT: 'MAIN_LOGO_ALT_TEXT',
  PARTNERING_ONE_TEXT: 'PARTNERING_ONE_TEXT',
  HEADER_HOME_ICON_ALT_TEXT: 'HEADER_HOME_ICON_ALT_TEXT',
  SEARCH_LABEL: 'SEARCH_LABEL',
  SEARCH_FILTER_BY_DELEGATES: 'SEARCH_FILTER_BY_DELEGATES',
  SEARCH_FILTER_BY_COMPANIES: 'SEARCH_FILTER_BY_COMPANIES',
  SEARCH_FILTER_PLACEHOLDER: 'SEARCH_FILTER_PLACEHOLDER',
  SEARCH_FILTER_BY_COMPANY_ASSETS: 'SEARCH_FILTER_BY_COMPANY_ASSETS',
  SEARCH_FILTER_BY_ALL_CATEGORIES: 'SEARCH_FILTER_BY_ALL_CATEGORIES',
  SEARCH_FILTERS_TITLE: 'SEARCH_FILTERS_TITLE',
  SEARCH_NO_RESULTS: 'SEARCH_NO_RESULTS',
  SEARCH_RESET_QUERY: 'SEARCH_RESET_QUERY',
  SEARCH_RESET_SEARCH_BUTTON: 'SEARCH_RESET_SEARCH_BUTTON',
  SEARCH_RESULT_TITLE: 'SEARCH_RESULT_TITLE',
  SAVE_SEARCH_BUTTON: 'SAVE_SEARCH_BUTTON',
  SEARCH_FORM_ALERT: 'SEARCH_FORM_ALERT',
  SEARCH_MENU_DAILY: 'SEARCH_MENU_DAILY',
  SEARCH_MENU_WEEKLY: 'SEARCH_MENU_WEEKLY',
  SAVE_SEARCH_TITLE: 'SAVE_SEARCH_TITLE',
  SEARCH_NAME_LABEL: 'SEARCH_NAME_LABEL',
  SEARCH_FORM_LABEL: 'SEARCH_FORM_LABEL',
  SEARCH_NO_NOTIFICATION: 'SEARCH_NO_NOTIFICATION',
  SEARCH_ADD_TO_ALERTS_BTN: 'SEARCH_ADD_TO_ALERTS_BTN',
  SEARCH_FILTER_BY_DATE: 'SEARCH_FILTER_BY_DATE',
  SEARCH_FILTER_BY_DATE_TO: 'SEARCH_FILTER_BY_DATE_TO',
  SEARCH_FILTER_BY_DATE_FROM: 'SEARCH_FILTER_BY_DATE_FROM',
  SEARCH_FILTER_BY_DATE_LABEL: 'SEARCH_FILTER_BY_DATE_LABEL',
  SEARCH_FILTER_BY_EVENT: 'SEARCH_FILTER_BY_EVENT',
  SEARCH_FILTER_BY_EVENT_TOOLTIP: 'SEARCH_FILTER_BY_EVENT_TOOLTIP',
  SEARCH_FILTER_BY_RECENT: 'SEARCH_FILTER_BY_RECENT',
  SEARCH_FILTER_BY_RECENT_WEEK: 'SEARCH_FILTER_BY_RECENT_WEEK',
  SEARCH_FILTER_BY_RECENT_MONTH: 'SEARCH_FILTER_BY_RECENT_MONTH',
  SEARCH_FILTER_BY_RECENT_THREE_MONTHS: 'SEARCH_FILTER_BY_RECENT_THREE_MONTHS',
  SEARCH_FILTER_BY_DATE_RANGE: 'SEARCH_FILTER_BY_DATE_RANGE',
  NEW_ITEMS_LABEL: 'NEW_ITEMS_LABEL',
  NEW_ITEMS_DESCRIPTION: 'NEW_ITEMS_DESCRIPTION',
  SEARCH_FILTER_BY_EVENT_LABEL: 'SEARCH_FILTER_BY_EVENT_LABEL',
  SEARCH_FILTER_BY_RECENT_LABEL: 'SEARCH_FILTER_BY_RECENT_LABEL',
  SEARCH_FILTER_BY_DATE_LABEL_EMPTY: 'SEARCH_FILTER_BY_DATE_LABEL_EMPTY',
  SEARCH_FILTER_BY_DATE_SUBMIT: 'SEARCH_FILTER_BY_DATE_SUBMIT',
  SEARCH_FILTER_META_CLOSE: 'SEARCH_FILTER_META_CLOSE',
  SEARCH_FILTER_SELECT_SUBMIT: 'SEARCH_FILTER_SELECT_SUBMIT',
  SEARCH_GROUP_BY: 'SEARCH_GROUP_BY',
  SEARCH_BY_EVENT: 'SEARCH_BY_EVENT',
  SEARCH_BY_HISTORY: 'SEARCH_BY_HISTORY',
  SEARCH_BY_PROFILE_UPDATED: 'SEARCH_BY_PROFILE_UPDATED',
  SEARCH_HISTORY_FILTER_REMOVE: 'SEARCH_HISTORY_FILTER_REMOVE',
  SEARCH_HISTORY_FILTER_MY_MEETINGS: 'SEARCH_HISTORY_FILTER_MY_MEETINGS',
  SEARCH_HISTORY_FILTER_PERSONAL: 'SEARCH_HISTORY_FILTER_PERSONAL',
  SEARCH_HISTORY_FILTER_COMPANY_HISTORY: 'SEARCH_HISTORY_FILTER_COMPANY_HISTORY',
  SEARCH_HISTORY_FILTER_NO_HISTORY: 'SEARCH_HISTORY_FILTER_NO_HISTORY',
  DEFAULT_BY_EVENT: 'DEFAULT_BY_EVENT',
  FILTER_BY_MULTIPLE: 'FILTER_BY_MULTIPLE',
  GROUP_BY_COMPANY: 'GROUP_BY_COMPANY',
  FILTER_BY_ALL: 'FILTER_BY_ALL',
  FILTER_BY_EXCLUDE: 'FILTER_BY_EXCLUDE',
  NO_GROUPING: 'NO_GROUPING',
  SEARCH_SORT_BY: 'SEARCH_SORT_BY',
  SEARCH_RESULT_COMPANY_LOGO_ALT: 'SEARCH_RESULT_COMPANY_LOGO_ALT',
  CONTACT_BUTTON: 'CONTACT_BUTTON',
  EXISTING_CONVERSATION: 'EXISTING_CONVERSATION',
  SEARCH_RESULTS_ITEM_READ_MORE_BTN: 'SEARCH_RESULTS_ITEM_READ_MORE_BTN',
  CUSTOM_LIST_BTN: 'CUSTOM_LIST_BTN',
  FETCHING_ERROR: 'FETCHING_ERROR',
  PROFILE_SECTION_EMPTY: 'PROFILE_SECTION_EMPTY',
  PROFILE_EVENTS: 'PROFILE_EVENTS',
  PROFILE_CURRENT_EVENTS: 'PROFILE_CURRENT_EVENTS',
  PROFILE_PAST_EVENTS: 'PROFILE_PAST_EVENTS',
  COMPANY_PROFILE_SECTION_SUMMARY: 'COMPANY_PROFILE_SECTION_SUMMARY',
  COMPANY_PROFILE_SECTION_PRODUCTS: 'COMPANY_PROFILE_SECTION_PRODUCTS',
  COMPANY_PROFILE_SECTION_COLLABORATIONS: 'COMPANY_PROFILE_SECTION_COLLABORATIONS',
  COMPANY_PROFILE_SUBSECTION_STRATEGY: 'COMPANY_PROFILE_SUBSECTION_STRATEGY',
  COMPANY_PROFILE_SUBSECTION_CLIENT_PORTFOLIO: 'COMPANY_PROFILE_SUBSECTION_CLIENT_PORTFOLIO',
  COMPANY_PROFILE_SECTION_ADDITIONAL_INFO: 'COMPANY_PROFILE_SECTION_ADDITIONAL_INFO',
  COMPANY_PROFILE_SUBSECTION_HIGHLIGHTS: 'COMPANY_PROFILE_SUBSECTION_HIGHLIGHTS',
  COMPANY_PROFILE_SUBSECTION_ANTICIPATED_HIGHLIGHTS: 'COMPANY_PROFILE_SUBSECTION_ANTICIPATED_HIGHLIGHTS',
  COMPANY_PROFILE_SECTION_ATTACHMENTS: 'COMPANY_PROFILE_SECTION_ATTACHMENTS',
  COMPANY_PROFILE_SECTION_CATEGORIZATION: 'COMPANY_PROFILE_SECTION_CATEGORIZATION',
  COMPANY_PROFILE_SUBSECTION_MAIN_SECTOR: 'COMPANY_PROFILE_SUBSECTION_MAIN_SECTOR',
  COMPANY_PROFILE_SUBSECTION_SUBSECTORS: 'COMPANY_PROFILE_SUBSECTION_SUBSECTORS',
  COMPANY_PROFILE_SUBSECTION_TERAPEUTIC_AREA: 'COMPANY_PROFILE_SUBSECTION_TERAPEUTIC_AREA',
  COMPANY_PROFILE_SECTION_COMPANY_DATA: 'COMPANY_PROFILE_SECTION_COMPANY_DATA',
  COMPANY_PROFILE_SUBSECTION_EMPLOYEES: 'COMPANY_PROFILE_SUBSECTION_EMPLOYEES',
  COMPANY_PROFILE_SUBSECTION_PHDS_NUMBER: 'COMPANY_PROFILE_SUBSECTION_PHDS_NUMBER',
  COMPANY_PROFILE_SUBSECTION_FOUNDED_YEAR: 'COMPANY_PROFILE_SUBSECTION_FOUNDED_YEAR',
  COMPANY_PROFILE_SUBSECTION_FOUNDATION_SOURCE: 'COMPANY_PROFILE_SUBSECTION_FOUNDATION_SOURCE',
  COMPANY_PROFILE_SUBSECTION_OWNERSHIP_STATE: 'COMPANY_PROFILE_SUBSECTION_OWNERSHIP_STATE',
  COMPANY_PROFILE_SECTION_CONTACTS: 'COMPANY_PROFILE_SECTION_CONTACTS',
  COMPANY_PROFILE_SECTION_INVESTMENT: 'COMPANY_PROFILE_SECTION_INVESTMENT',
  COMPANY_PROFILE_SUBSECTION_INVESTMENT_TIMEFRAME: 'COMPANY_PROFILE_SUBSECTION_INVESTMENT_TIMEFRAME',
  COMPANY_PROFILE_SUBSECTION_INVESTMENT_STAGE: 'COMPANY_PROFILE_SUBSECTION_INVESTMENT_STAGE',
  COMPANY_PROFILE_SUBSECTION_TICKER_SYMBOL: 'COMPANY_PROFILE_SUBSECTION_TICKER_SYMBOL',
  COMPANY_PROFILE_SUBSECTION_STOCK_EXCHANGE: 'COMPANY_PROFILE_SUBSECTION_STOCK_EXCHANGE',
  COMPANY_PROFILE_SUBSECTION_SECONDARY_LISTINGS: 'COMPANY_PROFILE_SUBSECTION_SECONDARY_LISTINGS',
  COMPANY_PROFILE_SUBSECTION_IPO: 'COMPANY_PROFILE_SUBSECTION_IPO',
  COMPANY_PROFILE_SUBSECTION_ADDITIONAL_LISTING_INFO: 'COMPANY_PROFILE_SUBSECTION_ADDITIONAL_LISTING_INFO',
  COMPANY_CARD_OVERVIEW: 'COMPANY_CARD_OVERVIEW',
  COMPANY_CARD_SUMMARY: 'COMPANY_CARD_SUMMARY',
  COMPANY_CARD_MAIN_SECTOR: 'COMPANY_CARD_MAIN_SECTOR',
  COMPANY_CARD_SUBSECTOR: 'COMPANY_CARD_SUBSECTOR',
  COMPANY_CARD_THERAPEUTIC_AREA: 'COMPANY_CARD_THERAPEUTIC_AREA',
  COMPANY_PROFILE_BTN: 'COMPANY_PROFILE_BTN',
  COMPANY_CARD_PROFILE_BUTTON: 'COMPANY_CARD_PROFILE_BUTTON',
  ASSET_PRODUCT_DESCRIPTION: 'ASSET_PRODUCT_DESCRIPTION',
  ASSET_FIELD_OF_USE_RESTRICTIONS: 'ASSET_FIELD_OF_USE_RESTRICTIONS',
  ASSET_CLINICAL_STRATEGY: 'ASSET_CLINICAL_STRATEGY',
  ASSET_KEY_PUBLICATIONS: 'ASSET_KEY_PUBLICATIONS',
  ASSET_IP_RIGHTS: 'ASSET_IP_RIGHTS',
  ASSET_PARTNERS: 'ASSET_PARTNERS',
  ASSET_URL: 'ASSET_URL',
  ASSET_ATTACHMENTS: 'ASSET_ATTACHMENTS',
  ASSET_MAIN_THERAPEUTIC_SECTOR: 'ASSET_MAIN_THERAPEUTIC_SECTOR',
  ASSET_THERAPEUTIC_SUBSECTOR: 'ASSET_THERAPEUTIC_SUBSECTOR',
  ASSET_MOLECULE_TYPE: 'ASSET_MOLECULE_TYPE',
  ASSET_MODE_OF_ADMINISTRATION: 'ASSET_MODE_OF_ADMINISTRATION',
  ASSET_PRIMARY_MARKET: 'ASSET_PRIMARY_MARKET',
  ASSET_SERVICE_DESCRIPTION: 'ASSET_SERVICE_DESCRIPTION',
  ASSET_SERVICE_CATEGORY: 'ASSET_SERVICE_CATEGORY',
  ASSET_SUBCATEGORIES: 'ASSET_SUBCATEGORIES',
  ASSET_SERVICE_STATUS: 'ASSET_SERVICE_STATUS',
  ASSET_SERVICE_AVAILABILITY: 'ASSET_SERVICE_AVAILABILITY',
  ASSET_TECHNOLOGY_DESCRIPTION: 'ASSET_TECHNOLOGY_DESCRIPTION',
  ASSET_CATEGORIZATION: 'ASSET_CATEGORIZATION',
  ASSET_SECTOR: 'ASSET_SECTOR',
  ASSET_SUBSECTOR: 'ASSET_SUBSECTOR',
  ASSET_ORPHAN_DISEASE_INDICATION: 'ASSET_ORPHAN_DISEASE_INDICATION',
  ASSET_DEVELOPMENT_PHASE: 'ASSET_DEVELOPMENT_PHASE',
  ASSET_PARTNERING_STATUS: 'ASSET_PARTNERING_STATUS',
  ASSET_MARKETING_RIGHTS: 'ASSET_MARKETING_RIGHTS',
  DELEGATE_PROFILE_SECTION_PARTNERING_OBJECTIVES: 'DELEGATE_PROFILE_SECTION_PARTNERING_OBJECTIVES',
  DELEGATE_PROFILE_SECTION_PROF_BACKGROUND: 'DELEGATE_PROFILE_SECTION_PROF_BACKGROUND',
  DELEGATE_PROFILE_SECTION_EXPERTISE_AREA: 'DELEGATE_PROFILE_SECTION_EXPERTISE_AREA',
  DELEGATE_PROFILE_SECTION_AFFILIATIONS: 'DELEGATE_PROFILE_SECTION_AFFILIATIONS',
  DELEGATE_PROFILE_SECTION_DEALS: 'DELEGATE_PROFILE_SECTION_DEALS',
  DELEGATE_PROFILE_SECTION_ATTACHMENTS: 'DELEGATE_PROFILE_SECTION_ATTACHMENT',
  DELEGATE_PROFILE_SECTION_SHARED_CONTACT_INFO: 'DELEGATE_PROFILE_SECTION_SHARED_CONTACT_INFO',
  DELEGATE_PROFILE_SECTION_SHARED_CONTACT_PHONE: 'DELEGATE_PROFILE_SECTION_SHARED_CONTACT_PHONE',
  DELEGATE_PROFILE_SECTION_SHARED_CONTACT_EMAIL: 'DELEGATE_PROFILE_SECTION_SHARED_CONTACT_EMAIL',
  DELEGATE_PROFILE_SECTION_MAIN_INFO: 'DELEGATE_PROFILE_SECTION_MAIN_INFO',
  DELEGATE_PROFILE_SUBSECTION_ADDRESS: 'DELEGATE_PROFILE_SUBSECTION_ADDRESS',
  DELEGATE_PROFILE_SUBSECTION_WEBSITE: 'DELEGATE_PROFILE_SUBSECTION_WEBSITE',
  LATEST_ASSETS_TITLE: 'LATEST_ASSETS_TITLE',
  LATEST_ASSETS_BIO_TAB: 'LATEST_ASSETS_BIO_TAB',
  LATEST_ASSETS_TECH_TAB: 'LATEST_ASSETS_TECH_TAB',
  LATEST_ASSETS_MED_TAB: 'LATEST_ASSETS_MED_TAB',
  LATEST_ASSETS_SERVICE_TAB: 'LATEST_ASSETS_SERVICE_TAB',
  LATEST_ASSETS_SELL_ALL_BUTTON: 'LATEST_ASSETS_SELL_ALL_BUTTON',
  PROFILES_BREADCRUMBDS_COMPANY_PROFILE: 'PROFILES_BREADCRUMBDS_COMPANY_PROFILE',
  PROFILES_BREADCRUMBDS_ALL_PRODUCTS: 'PROFILES_BREADCRUMBDS_ALL_PRODUCTS',
  PROFILES_BREADCRUMBDS_LATEST_COMPANY_PRODUCTS: 'PROFILES_BREADCRUMBDS_LATEST_COMPANY_PRODUCTS',
  PROFILES_BREADCRUMBDS_ALL_DELEGATES: 'PROFILES_BREADCRUMBDS_ALL_DELEGATES',
  ASSET_TECHNOLOGIES_SHORT_NAME: 'ASSET_TECHNOLOGIES_SHORT_NAME',
  ASSET_SERVICES_SHORT_NAME: 'ASSET_SERVICES_SHORT_NAME',
  ASSET_BIOTECH_SHORT_NAME: 'ASSET_BIOTECH_SHORT_NAME',
  ASSET_MEDTECH_SHORT_NAME: 'ASSET_MEDTECH_SHORT_NAME',
  SORT_MOST_RECENT: 'SORT_MOST_RECENT',
  SORT_LEAST_RECENT: 'SORT_LEAST_RECENT',
  SORT_TEXT_UP: 'SORT_TEXT_UP',
  SORT_TEXT_BOTTOM: 'SORT_TEXT_BOTTOM',
  ALL_PRODUCT_AND_SERVICES_TITLE: 'ALL_PRODUCT_AND_SERVICES_TITLE',
  ALL_PRODUCTS_FILTER_BY_EVENT_LABEL: 'ALL_PRODUCTS_FILTER_BY_EVENT_LABEL',
  ALL_PRODUCTS_FILTER_BY_MOLECULE_LABEL: 'ALL_PRODUCTS_FILTER_BY_MOLECULE_LABEL',
  ALL_PRODUCTS_FILTER_BY_PHASE_LABEL: 'ALL_PRODUCTS_FILTER_BY_PHASE_LABEL',
  ALL_PRODUCTS_FILTER_BY_THERAPEUTIC_LABEL: 'ALL_PRODUCTS_FILTER_BY_THERAPEUTIC_LABEL',
  ALL_PRODUCTS_EMPTY_ASSETS_MESSAGE: 'ALL_PRODUCTS_EMPTY_ASSETS_MESSAGE',
  IN_CUSTOM_LIST: 'IN_CUSTOM_LIST',
  ADD_PROSPECT_TO_CUSTOM_LIST: 'ADD_PROSPECT_TO_CUSTOM_LIST',
  NAME_YOUR_CUSTOM_LIST: 'NAME_YOUR_CUSTOM_LIST',
  ADD_YOUR_CUSTOM_LIST: 'ADD_YOUR_CUSTOM_LIST',
  EDIT_CUSTOM_LISTS: 'EDIT_CUSTOM_LISTS',
  EMPTY_CUSTOM_LISTS_TITLE: 'EMPTY_CUSTOM_LISTS_TITLE',
  EMPTY_ECOMMERCE_CUSTOM_LISTS_TITLE: 'EMPTY_ECOMMERCE_CUSTOM_LISTS_TITLE',
  EMPTY_CUSTOM_LISTS_BTN: 'EMPTY_CUSTOM_LISTS_BTN',
  CUSTOM_LIST_SEARCH_PLACEHOLDER: 'CUSTOM_LIST_SEARCH_PLACEHOLDER',
  CUSTOM_LIST_SEARCH_LABEL: 'CUSTOM_LIST_SEARCH_LABEL',
  CUSTOM_LIST_POPUP_CANCEL_BTN: 'CUSTOM_LIST_POPUP_CANCEL_BTN',
  CUSTOM_LIST_POPUP_CONFIRM_BTN: 'CUSTOM_LIST_POPUP_CONFIRM_BTN',
  CUSTOM_LIST_POPUP_ADD_BTN: 'CUSTOM_LIST_POPUP_ADD_BTN',
  CUSTOM_LIST_NAME_UNIQUE_ERROR: 'CUSTOM_LIST_NAME_UNIQUE_ERROR',
  CUSTOM_LIST_TABLE_HEADER_TITLE: 'CUSTOM_LIST_TABLE_HEADER_TITLE',
  CUSTOM_LIST_TABLE_HEADER_EVENT_NAME: 'CUSTOM_LIST_TABLE_HEADER_EVENT_NAME',
  CUSTOM_LIST_TABLE_HEADER_CONTACT_STATUS: 'CUSTOM_LIST_TABLE_HEADER_CONTACT_STATUS',
  CUSTOM_LIST_TABLE_HEADER_UPDATED: 'CUSTOM_LIST_TABLE_HEADER_UPDATED',
  CUSTOM_LIST_TABLE_HEADER_PHASE: 'CUSTOM_LIST_TABLE_HEADER_PHASE',
  CUSTOM_LIST_TABLE_HEADER_NDA: 'CUSTOM_LIST_TABLE_HEADER_NDA',
  CUSTOM_LIST_TABLE_HEADER_NOTES: 'CUSTOM_LIST_TABLE_HEADER_NOTES',
  CUSTOM_LIST_TABLE_HEADER_LAST_EVENT: 'CUSTOM_LIST_TABLE_HEADER_LAST_EVENT',
  CUSTOM_LIST_TABLE_HEADER_FUTURE_EVENTS: 'CUSTOM_LIST_TABLE_HEADER_FUTURE_EVENTS',
  CUSTOM_LIST_TABLE_BTN_FUTURE_EVENTS: 'CUSTOM_LIST_TABLE_BTN_FUTURE_EVENTS',
  CUSTOM_LIST_TABLE_HEADER_PRIORITY: 'CUSTOM_LIST_TABLE_HEADER_PRIORITY',
  CUSTOM_LIST_TABLE_TOOLTIP_BOTH_ATTENDING_SAME: 'CUSTOM_LIST_TABLE_TOOLTIP_BOTH_ATTENDING_SAME',
  CUSTOM_LIST_TABLE_TOOLTIP_BOTH_ATTENDING: 'CUSTOM_LIST_TABLE_TOOLTIP_BOTH_ATTENDING',
  CUSTOM_LIST_TABLE_TOOLTIP_NOT_ATTENDING: 'CUSTOM_LIST_TABLE_TOOLTIP_NOT_ATTENDING',
  CUSTOM_LIST_TABLE_HEADER_CUSTOM_TAG: 'CUSTOM_LIST_TABLE_HEADER_CUSTOM_TAG',
  CUSTOM_LIST_TABLE_HEADER_DATE_ADDED: 'CUSTOM_LIST_TABLE_HEADER_DATE_ADDED',
  CUSTOM_LIST_TABLE_HEADER_CONTACT: 'CUSTOM_LIST_TABLE_HEADER_CONTACT',
  CUSTOM_LIST_TABLE_HEADER_COMPANY_NAME: 'CUSTOM_LIST_TABLE_HEADER_COMPANY_NAME',
  CUSTOM_LIST_TABLE_CONTACT_BUTTON: 'CUSTOM_LIST_TABLE_CONTACT_BUTTON',
  CUSTOM_LIST_TABLE_CATEGORIES_BUTTON: 'CUSTOM_LIST_TABLE_CATEGORIES_BUTTON',
  CUSTOM_LIST_TABLE_ADD_CATEGORY_TITLE: 'CUSTOM_LIST_TABLE_ADD_CATEGORY_TITLE',
  CUSTOM_LIST_ADD_CATEGORY_SUB_TITLE: 'CUSTOM_LIST_ADD_CATEGORY_SUB_TITLE',
  CUSTOM_LIST_TABLE_SORT_CATEGORY: 'CUSTOM_LIST_TABLE_SORT_CATEGORY',
  CUSTOM_LIST_POPOVER_CANCEL_BTN: 'CUSTOM_LIST_POPOVER_CANCEL_BTN',
  CUSTOM_LIST_POPOVER_CONFIRM_BTN: 'CUSTOM_LIST_POPOVER_CONFIRM_BTN',
  CUSTOM_LIST_CUSTOM_STATUS_NOT_SET: 'CUSTOM_LIST_CUSTOM_STATUS_NOT_SET',
  CUSTOM_LIST_ADD_NEW_STATUS_BTN: 'CUSTOM_LIST_ADD_NEW_STATUS_BTN',
  CUSTOM_LIST_NO_MORE_STATUSES: 'CUSTOM_LIST_NO_MORE_STATUSES',
  CUSTOM_LIST_EDIT_CUSTOM_STATUS: 'CUSTOM_LIST_EDIT_CUSTOM_STATUS',
  CUSTOM_LIST_DELETE_CUSTOM_STATUS_TITLE: 'CUSTOM_LIST_DELETE_CUSTOM_STATUS_TITLE',
  CUSTOM_LIST_DELETE_CUSTOM_STATUS_TEXT: 'CUSTOM_LIST_DELETE_CUSTOM_STATUS_TEXT',
  CUSTOM_LIST_DUPLICATE_CUSTOM_STATUS_NAME_ERROR_TITLE: 'CUSTOM_LIST_DUPLICATE_CUSTOM_STATUS_NAME_ERROR_TITLE',
  CUSTOM_LIST_DUPLICATE_CUSTOM_STATUS_NAME_ERROR_TEXT: 'CUSTOM_LIST_DUPLICATE_CUSTOM_STATUS_NAME_ERROR_TEXT',
  CUSTOM_LIST_EMPTY_CUSTOM_STATUS_NAME_ERROR_TITLE: 'CUSTOM_LIST_EMPTY_CUSTOM_STATUS_NAME_ERROR_TITLE',
  CUSTOM_LIST_EMPTY_CUSTOM_STATUS_NAME_ERROR_TEXT: 'CUSTOM_LIST_EMPTY_CUSTOM_STATUS_NAME_ERROR_TEXT',
  CUSTOM_LIST_KEEP_EDITING: 'CUSTOM_LIST_KEEP_EDITING',

  MOVE_OR_COPY_TO_CUSTOM_LIST: 'MOVE_OR_COPY_TO_CUSTOM_LIST',
  KEEP_PROSPECT_COPY_IN_ORIGNAL_LIST: 'KEEP_PROSPECT_COPY_IN_ORIGNAL_LIST',
  ATTENDEES_TITLE: 'ATTENDEES_TITLE',
  MOVE_TO_DIFFERENT_CUSTOM_LIST: 'MOVE_TO_DIFFERENT_CUSTOM_LIST',
  DOWNLOAD_CUSTOM_LIST: 'DOWNLOAD_CUSTOM_LIST',
  DELETE_CUSTOM_LIST: 'DELETE_CUSTOM_LIST',
  SHOW_ON_CUSTOM_LIST_PAGE: 'SHOW_ON_CUSTOM_LIST_PAGE',
  DELETE_A_CUSTOM_LIST: 'DELETE_A_CUSTOM_LIST',
  ARE_YOU_SURE_TO_DELETE_A_CUSTOM_LIST: 'ARE_YOU_SURE_TO_DELETE_A_CUSTOM_LIST',
  DELETE_ITEMS: 'DELETE_ITEMS',
  DELETE_BUTTON: 'DELETE_BUTTON',
  DELETE_SINGLE_SAVED_SEARCH: 'DELETE_SINGLE_SAVED_SEARCH',
  DELETE_MULTIPLE_SAVED_SEARCHES: 'DELETE_MULTIPLE_SAVED_SEARCHES',
  DELETE_SAVED_SEARCH: 'DELETE_SAVED_SEARCH',
  DO_YO_WANT_PERMANENTLY_DELETE: 'DO_YO_WANT_PERMANENTLY_DELETE',
  NO_ITEM_SELECTED: 'NO_ITEM_SELECTED',
  YOU_NEED_TO_SELECT: 'YOU_NEED_TO_SELECT',
  YOU_NEED_TO_SELECT_ALERTS_TO_DELETE: 'YOU_NEED_TO_SELECT_ALERTS_TO_DELETE',
  YOU_NEED_TO_SELECT_TO_MOVE: 'YOU_NEED_TO_SELECT_TO_MOVE',
  YOU_NEED_TO_SELECT_PROFILES_TO_ADD_ALERTS: 'YOU_NEED_TO_SELECT_PROFILES_TO_ADD_ALERTS',
  CONFIRM_BUTTON: 'CONFIRM_BUTTON',
  CANCEL_BUTTON: 'CANCEL_BUTTON',
  ADD_NOTE_HERE: 'ADD_NOTE_HERE',
  ADD_NOTE: 'ADD_NOTE',
  EDIT_NOTE: 'EDIT_NOTE',
  SAVE: 'SAVE',
  DELETE_NOTE: 'DELETE_NOTE',
  REMOVE_ALL: 'REMOVE_ALL',
  REMOVE: 'REMOVE',
  CHARACTERS_LEFT: 'CHARACTERS_LEFT',
  CHARACTER_LEFT: 'CHARACTER_LEFT',
  DUPLICATE_ERROR_TITLE: 'DUPLICATE_ERROR_TITLE',
  DUPLICATE_ERROR_TEXT: 'DUPLICATE_ERROR_TEXT',
  ASSET_COMPANY_TITLE: 'ASSET_COMPANY_TITLE',
  PROFILE_TITLE_TYPE: 'PROFILE_TITLE_TYPE',
  PROFILE_TITLE_ASC: 'PROFILE_TITLE_ASC',
  PROFILE_TITLE_DESC: 'PROFILE_TITLE_DESC',
  ALERT_DATE_ADDED_ASCENDING: 'ALERT_DATE_ADDED_ASCENDING',
  ALERT_DATE_ADDED_DESCENDING: 'ALERT_DATE_ADDED_DESCENDING',
  ALERT_DATE_UPDATE_ASCENDING: 'ALERT_DATE_UPDATE_ASCENDING',
  ALERT_DATE_UPDATE_DESCENDING: 'ALERT_DATE_UPDATE_DESCENDING',
  ALERT_SORT_BY_PROFILE_TITLE: 'ALERT_SORT_BY_PROFILE_TITLE',
  ALERT_SORT_BY_PROFILE_DATE_ADDED: 'ALERT_SORT_BY_PROFILE_DATE_ADDED',
  ALERT_SORT_BY_PROFILE_DATE_UPDATED: 'ALERT_SORT_BY_PROFILE_DATE_UPDATED',
  ALERT_SORT_BY_FREQUENCY: 'ALERT_SORT_BY_FREQUENCY',
  ALERT_FREQUENCY: 'ALERT_FREQUENCY',
  COMPANY_NAME_ASC: 'COMPANY_NAME_ASC',
  COMPANY_NAME_DESC: 'COMPANY_NAME_DESC',
  DATE_ADDED_ASCENDING: 'DATE_ADDED_ASCENDING',
  DATE_ADDED_DESCENDING: 'DATE_ADDED_DESCENDING',
  NEWEST_EVENT: 'NEWEST_EVENT',
  OLDEST_EVENT: 'OLDEST_EVENT',
  MOST_RECENT_EVENT_FIRST: 'MOST_RECENT_EVENT_FIRST',
  NEXT_EVENT: 'NEXT_EVENT',
  STATUS_TYPE: 'STATUS_TYPE',
  DATE_UPDATED_ASCENDING: 'DATE_UPDATED_ASCENDING',
  DATE_UPDATED_DESCENDING: 'DATE_UPDATED_DESCENDING',
  DONE: 'DONE',
  NOT_DONE: 'NOT_DONE',
  NEWEST_NOTE: 'NEWEST_NOTE',
  OLDEST_NOTE: 'OLDEST_NOTE',
  PRIORITY_HIGH_TO_NOT_SET: 'PRIORITY_HIGH_TO_NOT_SET',
  PRIORITY_NOT_SET_TO_HIGH: 'PRIORITY_NOT_SET_TO_HIGH',
  NEWEST_TEXTS: 'NEWEST_TEXTS',
  OLDEST_TEXTS: 'OLDEST_TEXTS',
  STATUS_ASC: 'STATUS_ASC',
  STATUS_DESC: 'STATUS_DESC',
  STATUS: 'STATUS',
  SETTINGS: 'SETTINGS',
  MOVE_PROSPECTS: 'MOVE_PROSPECTS',
  LOGOUT: 'LOGOUT',
  MOVE_PROSPECT_TO_OTHER_CUSTOM_LISTS: 'MOVE_PROSPECT_TO_OTHER_CUSTOM_LISTS',
  UNSAVED_SETTINGS: 'UNSAVED_SETTINGS',
  YOU_HAVENOT_SAVED_CHANGES: 'YOU_HAVENOT_SAVED_CHANGES',
  CONTINUE_EDITING: 'CONTINUE_EDITING',
  CLOSE_ANYWAY: 'CLOSE_ANYWAY',
  MEETING_STATUS_HISTORY_TITLE_FOR_FREE_USER: 'MEETING_STATUS_HISTORY_TITLE_FOR_FREE_USER',
  MEETING_STATUS_HISTORY_TITLE_FOR_PREMIUM_USER: 'MEETING_STATUS_HISTORY_TITLE_FOR_PREMIUM_USER',
  MEETING_PENDING_STATUS_COUNT: 'MEETING_PENDING_STATUS_COUNT',
  MEETING_PENDING_STATUS: 'MEETING_PENDING_STATUS',
  MEETING_PAST_STATUS: 'MEETING_PAST_STATUS',
  MEETING_PAST_STATUS_COUNT: 'MEETING_PAST_STATUS_COUNT',
  MEETING_UPCOMING_STATUS: 'MEETING_UPCOMING_STATUS',
  MEETING_DECLINED_STATUS: 'MEETING_DECLINED_STATUS',
  MEETING_CANCELED_STATUS: 'MEETING_CANCELED_STATUS',
  CONTACT_STATUS_DETAILS: 'CONTACT_STATUS_DETAILS',
  MEETING_NO_RESPONSE_STATUS: 'MEETING_NO_RESPONSE_STATUS',
  MEETING_NO_RESPONSE_STATUS_COUNT: 'MEETING_NO_RESPONSE_STATUS_COUNT',
  SEARCH_FILTER_SECTION_SEE_MORE: 'SEARCH_FILTER_SECTION_SEE_MORE',
  SEARCH_FILTER_SECTION_SEE_LESS: 'SEARCH_FILTER_SECTION_SEE_LESS',
  IMPORT: 'IMPORT',
  IMPORT_PROSPECTS_FROM: 'IMPORT_PROSPECTS_FROM',
  IMPORT_PROSPECTS: 'IMPORT_PROSPECTS',
  IMPORT_PROSPECTS_TO: 'IMPORT_PROSPECTS_TO',
  ADD_PROSPECTS_TO_CUSTOM_LIST: 'ADD_PROSPECTS_TO_CUSTOM_LIST',
  MANAGE_AND_TRACK_LIVE_PROSPECTS: 'MANAGE_AND_TRACK_LIVE_PROSPECTS',
  PROSPECT_FILTER_INCOMING: 'PROSPECT_FILTER_INCOMING',
  PROSPECT_FILTER_OUTGOING: 'PROSPECT_FILTER_OUTGOING',
  PROSPECT_FILTER_REQUESTED: 'PROSPECT_FILTER_REQUESTED',
  PROSPECT_FILTER_AGREED: 'PROSPECT_FILTER_AGREED',
  PROSPECT_FILTER_DECLINED: 'PROSPECT_FILTER_DECLINED',
  PROSPECT_FILTER_CANCELLED: 'PROSPECT_FILTER_CANCELLED',
  PROSPECT_FILTER_SECTION_REQUESTS: 'PROSPECT_FILTER_SECTION_REQUESTS',
  UNTAGGED_PROSPECT_FILTER: 'UNTAGGED_PROSPECT_FILTER',
  PROSPECT_FILTER_SECTION_TAGS: 'PROSPECT_FILTER_SECTION_TAGS',
  PROSPECT_FILTER_SECTION_STATUS: 'PROSPECT_FILTER_SECTION_STATUS',
  IMPORT_ALL_COUNT_PROSPECT: 'IMPORT_ALL_COUNT_PROSPECT',
  IMPORT_COUNT_PROSPECT: 'IMPORT_COUNT_PROSPECT',
  SELECT_SPECIFIC_PROSPECTS: 'SELECT_SPECIFIC_PROSPECTS',
  SELECT_ALL_LABEL: 'SELECT_ALL_LABEL',
  ALL_LABEL: 'ALL_LABEL',
  SELECT_PARTICIPANT: 'SELECT_PARTICIPANT',
  CREATE_A_NEW_CUSTOM_LIST: 'CREATE_A_NEW_CUSTOM_LIST',
  NEW_LIST: 'NEW_LIST',
  ADD_TO_EXISTING_LIST: 'ADD_TO_EXISTING_LIST',
  SEARCH_PLACEHOLDER_SUBSCRIBER_HEADING: 'SEARCH_PLACEHOLDER_SUBSCRIBER_HEADING',
  SEARCH_PLACEHOLDER_FREE_HEADING: 'SEARCH_PLACEHOLDER_FREE_HEADING',
  SEARCH_PLACEHOLDER_TIPS_HEADING: 'SEARCH_PLACEHOLDER_TIPS_HEADING',
  SEARCH_PLACEHOLDER_SUBSCRIBER_TIPS_1: 'SEARCH_PLACEHOLDER_SUBSCRIBER_TIPS_1',
  SEARCH_PLACEHOLDER_SUBSCRIBER_TIPS_2: 'SEARCH_PLACEHOLDER_SUBSCRIBER_TIPS_2',
  SEARCH_PLACEHOLDER_SUBSCRIBER_TIPS_3: 'SEARCH_PLACEHOLDER_SUBSCRIBER_TIPS_3',
  SEARCH_PLACEHOLDER_SUBSCRIBER_TIPS_4: 'SEARCH_PLACEHOLDER_SUBSCRIBER_TIPS_4',
  SEARCH_PLACEHOLDER_FREE_TIPS_1: 'SEARCH_PLACEHOLDER_FREE_TIPS_1',
  SEARCH_PLACEHOLDER_FREE_TIPS_2: 'SEARCH_PLACEHOLDER_FREE_TIPS_2',
  SEARCH_PLACEHOLDER_FREE_TIPS_3: 'SEARCH_PLACEHOLDER_FREE_TIPS_3',
  SEARCH_PLACEHOLDER_OPERATORS: 'SEARCH_PLACEHOLDER_OPERATORS',
  SEARCH_PLACEHOLDER_OPERATORS_TIPS_1: 'SEARCH_PLACEHOLDER_OPERATORS_TIPS_1',
  SEARCH_PLACEHOLDER_OPERATORS_TIPS_2: 'SEARCH_PLACEHOLDER_OPERATORS_TIPS_2',
  SEARCH_PLACEHOLDER_OPERATORS_TIPS_3: 'SEARCH_PLACEHOLDER_OPERATORS_TIPS_3',
  SEARCH_PLACEHOLDER_OPERATORS_TIPS_4: 'SEARCH_PLACEHOLDER_OPERATORS_TIPS_4',
  SEARCH_PLACEHOLDER_OPERATORS_TIPS_EXAMPLE_1: 'SEARCH_PLACEHOLDER_OPERATORS_TIPS_EXAMPLE_1',
  SEARCH_PLACEHOLDER_OPERATORS_TIPS_EXAMPLE_2: 'SEARCH_PLACEHOLDER_OPERATORS_TIPS_EXAMPLE_2',
  SEARCH_PLACEHOLDER_OPERATORS_TIPS_EXAMPLE_3: 'SEARCH_PLACEHOLDER_OPERATORS_TIPS_EXAMPLE_3',
  SEARCH_PLACEHOLDER_OPERATORS_TIPS_EXAMPLE_4: 'SEARCH_PLACEHOLDER_OPERATORS_TIPS_EXAMPLE_4',
  INBOX_TITLE: 'INBOX_TITLE',
  NEW_MESSAGES: 'NEW_MESSAGES',
  ONE_MAIL_PROMPT: 'ONE_MAIL_PROMPT',
  FILTER_BY_MOST_RECENT: 'FILTER_BY_MOST_RECENT',
  CLICK_HERE_TO_SUBSCRIBE: 'CLICK_HERE_TO_SUBSCRIBE',
  CLICK_HERE_TO_UPGRADE: 'CLICK_HERE_TO_UPGRADE',
  INBOX: 'INBOX',
  ATTENDING: 'ATTENDING',
  SIGN_UP_TO: 'SIGN_UP_TO',
  SEND_TO_ALL: 'SEND_TO_ALL',
  ATTENDEES_AT: 'ATTENDEES_AT',
  MOST_RECENT: 'MOST_RECENT',
  MOST_UNREAD: 'UNREAD',
  MENU_PROFILE: 'MENU_PROFILE',
  MENU_UNREAD: 'MENU_UNREAD',
  MENU_DELETE: 'MENU_DELETE',
  SORT_BY: 'SORT_BY',
  COMPANY_MESSAGE: 'COMPANY_MESSAGE',
  SEARCH_THE_PONE_PLUS_DATABASE: 'SEARCH_THE_PONE_PLUS_DATABASE',
  HUB_SEARCH_DESCRIPTION: 'HUB_SEARCH_DESCRIPTION',
  HUB_SEARCH_PLACEHOLDER: 'HUB_SEARCH_PLACEHOLDER',
  START_A_FILTERED_SEARCH: 'START_A_FILTERED_SEARCH',
  SUBMIT: 'SUBMIT',
  CONTACT_CENTER: 'CONTACT_CENTER',
  ANSWER_THE_LATEST_MESSAGES_IN: 'ANSWER_THE_LATEST_MESSAGES_IN',
  YOUR: 'YOUR',
  P1_PLUS_INBOX: 'P1_PLUS_INBOX',
  YOUR_CUSTOM_LISTS: 'YOUR_CUSTOM_LISTS',
  VIEW_AND_MANAGE_YOUR: 'VIEW_AND_MANAGE_YOUR',
  CUSTOM_LISTS: 'CUSTOM_LISTS',
  NOT_A_SUBSCRIBER: 'NOT_A_SUBSCRIBER',
  NOT_A_SUBSCRIBER_DESCRIPTION_1: 'NOT_A_SUBSCRIBER_DESCRIPTION_1',
  NOT_A_SUBSCRIBER_DESCRIPTION_2: 'NOT_A_SUBSCRIBER_DESCRIPTION_2',
  NOT_A_SUBSCRIBER_DESCRIPTION_3: 'NOT_A_SUBSCRIBER_DESCRIPTION_3',
  FIND_OUT_MORE: 'FIND_OUT_MORE',
  WELCOME_TO: 'WELCOME_TO',
  GO_TO: 'GO_TO',
  EVENT_PARTNERING: 'EVENT_PARTNERING',
  ACCESS_ALL_YOUR_UPCOMING_EVENTS: 'ACCESS_ALL_YOUR_UPCOMING_EVENTS',
  ACCESS_YOUR_UPCOMING_EVENT: 'ACCESS_YOUR_UPCOMING_EVENT',
  SEE_PAST_EVENTS: 'SEE_PAST_EVENTS',
  QUESTIONS_EMAIL_US_AT: 'QUESTIONS_EMAIL_US_AT',
  FOR_HELP_MANAGING_YOUR_P1_PLUS_ACCOUNT: 'FOR_HELP_MANAGING_YOUR_P1_PLUS_ACCOUNT',
  VIEW_THE_USER_GUIDE: 'VIEW_THE_USER_GUIDE',
  TERMS: 'TERMS',
  PRIVACY: 'PRIVACY',
  SORRY_YOUR_ACCOUNT_FOR_THIS_EVENT_IS_NOT_READY_YET: 'YOUR_ACCOUNT_FOR_THIS_EVENT_IS_NOT_READY_YET',
  SORRY_YOUR_ACCOUNT_FOR_THIS_EVENT_IS_BLOCKED: 'SORRY_YOUR_ACCOUNT_FOR_THIS_EVENT_IS_BLOCKED',
  SORRY_ACCESS_ISNT_OPEN_FOR_THIS_EVENT_JUST_YET: 'SORRY_ACCESS_ISNT_OPEN_FOR_THIS_EVENT_JUST_YET',
  SORRY_AGENDA_ISNT_OPEN_FOR_THIS_EVENT_JUST_YET: 'SORRY_AGENDA_ISNT_OPEN_FOR_THIS_EVENT_JUST_YET',
  NAME_ALREADY_EXISTS: 'NAME_ALREADY_EXISTS',
  DO_YOU_WANT_TO_REWRITE_SAVE: 'DO_YOU_WANT_TO_REWRITE_SAVE',
  YOU_HAVE_SAVED_YOUR_SEARCH: 'YOU_HAVE_SAVED_YOUR_SEARCH',
  SAVED_SEARCHES: 'SAVED_SEARCHES',
  SAVED_SEARCHES_NAME: 'SAVED_SEARCHES_NAME',
  SAVED_SEARCHES_NEW: 'SAVED_SEARCHES_NEW',
  SAVED_SEARCHES_SEARCH: 'SAVED_SEARCHES_SEARCH',
  SAVED_SEARCHES_NOTIFICATION: 'SAVED_SEARCHES_NOTIFICATION',
  SAVED_SEARCHES_RUN: 'SAVED_SEARCHES_RUN',
  MEETING_INMAIL_STATUS_COUNT: 'MEETING_INMAIL_STATUS_COUNT',
  SEE_ALL_MESSAGES: 'SEE_ALL_MESSAGES',
  YOU_CAN_RUN_ANY_SAVED_PARAMS: 'YOU_CAN_RUN_ANY_SAVED_PARAMS',
  SAVE_SEARCH_PARAMS: 'SAVE_SEARCH_PARAMS',
  SAVED_SEARCH: 'SAVED_SEARCH',
  ALERTS: 'ALERTS',
  ALERT: 'ALERT',
  ADD_EMAIL_ALERTS_TITLE: 'ADD_EMAIL_ALERTS_TITLE',
  EDIT_EMAIL_ALERTS_TITLE: 'EDIT_EMAIL_ALERTS_TITLE',
  EDIT_EMAIL_ALERTS_SUBTITLE: 'EDIT_EMAIL_ALERTS_SUBTITLE',
  ADD_ALERTS_IN_APP_ALERT_TOOLTIP: 'ADD_ALERTS_IN_APP_ALERT_TOOLTIP',
  ADD_ALERTS_IN_APP_ALERT_ADDED_TOOLTIP: 'ADD_ALERTS_IN_APP_ALERT_ADDED_TOOLTIP',
  ADD_ALERTS_EMAIL_ALERT_TOOLTIP: 'ADD_ALERTS_EMAIL_ALERT_TOOLTIP',
  ADD_ALERTS_EMAIL_ALERT_ADDED_TOOLTIP: 'ADD_ALERTS_EMAIL_ALERT_ADDED_TOOLTIP',
  ADD_ALERTS_BUTTON: 'ADD_ALERTS_BUTTON',
  ALERT_ADDED: 'ALERT_ADDED',
  ALERT_FREQUENCY_DAILY: 'ALERT_FREQUENCY_DAILY',
  ALERT_FREQUENCY_WEEKLY: 'ALERT_FREQUENCY_WEEKLY',
  ALERT_FREQUENCY_NO_NOTIFICATION: 'ALERT_FREQUENCY_NO_NOTIFICATION',
  ALERT_WITH_NOTIFICATION_ADDED: 'ALERT_WITH_NOTIFICATION_ADDED',
  ALERT_ADDED_SUBTITLE: 'ALERT_ADDED_SUBTITLE',
  ALERT_ADD_EMAIL_NOTIFICATION: 'ALERT_ADD_EMAIL_NOTIFICATION',
  ALERT_ADD_EMAIL_NOTIFICATION_SUBTITLE: 'ALERT_ADD_EMAIL_NOTIFICATION_SUBTITLE',
  DELETE_ALERTS_TITLE: 'DELETE_ALERTS_TITLE',
  DELETE_ALERTS_SUBTITLE: 'DELETE_ALERTS_SUBTITLE',
  DELETE_ALERTS_SHORTLIST: 'DELETE_ALERTS_SHORTLIST',
  DELETE_ALERTS_FROM_LIST_TITLE: 'DELETE_ALERTS_FROM_LIST_TITLE',
  DELETE_ALERTS_FROM_LIST_SUBTITLE: 'DELETE_ALERTS_FROM_LIST_SUBTITLE',
  DELETE_ALERT_FROM_LIST_TITLE: 'DELETE_ALERT_FROM_LIST_TITLE',
  DELETE_ALERT_FROM_LIST_SUBTITLE: 'DELETE_ALERT_FROM_LIST_SUBTITLE',
  ALERTS_DISABLED_LINK: 'ALERTS_DISABLED_LINK',
  NEW: 'NEW',
  MARK_AS_READ: 'MARK_AS_READ',
  MARK_ALL_AS_READ: 'MARK_ALL_AS_READ',
  MARK_ALL_AS_READ_WITHOUT_CHECKMARK: 'MARK_ALL_AS_READ_WITHOUT_CHECKMARK',
  UPDATED: 'UPDATED',
  NEW_ACTIVITY: 'NEW_ACTIVITY',
  VIEW_MORE_EVENTS: 'VIEW_MORE_EVENTS',
  EVENT_ATTENDED: 'EVENT_ATTENDED',
  EVENT_ATTENDING: 'EVENT_ATTENDING',
  HIGH: 'HIGH',
  MEDIUM: 'MEDIUM',
  LOW: 'LOW',
  NOT_SET: 'NOT_SET',
  FIND_CONNECT_AND_MANAGE: 'FIND_CONNECT_AND_MANAGE',
  LAUNCH_PARTNERING_ONE_PLUS: 'LAUNCH_PARTNERING_ONE_PLUS',
  TO_FIND_CONNECT_AND_MANAGE: 'TO_FIND_CONNECT_AND_MANAGE',
  UPCOMING_EVENT: 'UPCOMING_EVENT',
  UPCOMING_EVENTS: 'UPCOMING_EVENTS',
  PAST_EVENT: 'PAST_EVENT',
  PAST_EVENTS: 'PAST_EVENTS',
  SEE_ALL: 'SEE_ALL',
  SEE_YOUR: 'SEE_YOUR',
  EVENTS: 'EVENTS',
  EVENT: 'EVENT',
  PLUS: 'PLUS',
  MANAGE_COLUMNS: 'MANAGE_COLUMNS',
  SHOW_AND_HIDE_COLUMNS: 'SHOW_AND_HIDE_COLUMNS',
  THIS_MEETING_WAS_IMPORTED: 'THIS_MEETING_WAS_IMPORTED',
  THIS_MEETING_WAS_IMPORTED_FOR_TEAM: 'THIS_MEETING_WAS_IMPORTED_FOR_TEAM',
  PRIVATE_COMPANY_INDICATOR_TEXT: 'PRIVATE_COMPANY_INDICATOR_TEXT',
  UPDATES: 'UPDATES',
  MANAGE_ALERTS: 'MANAGE_ALERTS',
  MANAGE_ALERTS_ITEMS_TOTAL: 'MANAGE_ALERTS_ITEMS_TOTAL',
  MANAGE_ALERTS_HEADER_ALERT_ADDED: 'MANAGE_ALERTS_HEADER_ALERT_ADDED',
  MANAGE_ALERTS_HEADER_FREQUENCY: 'MANAGE_ALERTS_HEADER_FREQUENCY',
  UPDATES_TABLE_HEADER_ITEM: 'UPDATES_TABLE_HEADER_ITEM',
  UPDATES_TABLE_HEADER_UPDATES: 'UPDATES_TABLE_HEADER_UPDATES',
  UPDATES_TABLE_HEADER_LAST_UPDATED: 'UPDATES_TABLE_HEADER_LAST_UPDATED',
  UPDATES_TABLE_HEADER_READ: 'UPDATES_TABLE_HEADER_READ',
  GO_TO_SEARCH_TO_GET_STARTED: 'GO_TO_SEARCH_TO_GET_STARTED',
  YOU_ARE_MISSING_OUT: 'YOU_ARE_MISSING_OUT',
  YOU_HAVE_NO_ALERTS_SET_UP: 'YOU_HAVE_NO_ALERTS_SET_UP',
  FOR_EXAMPLE: 'FOR_EXAMPLE',
  TRACK_WHEN_ASSETS_CHANGE: 'TRACK_WHEN_ASSETS_CHANGE',
  FIND_OUT_WHICH_EVENT: 'FIND_OUT_WHICH_EVENT',
  GOOD_THINGS_COME: 'GOOD_THINGS_COME',
  THERE_ARE_NO_UPDATES: 'THERE_ARE_NO_UPDATES',
  IN_THE_MEANTIME: 'IN_THE_MEANTIME',
  MOVED_TO_SHORTLIST: 'MOVED_TO_SHORTLIST',
  PROSPECT_MOVED_TO_SHORTLIST: 'PROSPECT_MOVED_TO_SHORTLIST',
  PROSPECT_COPIED_TO_SHORTLIST: 'PROSPECT_COPIED_TO_SHORTLIST',
  TO: 'TO',
  TO_INCLUDE: 'TO_INCLUDE',
  MORE: 'MORE',
  COUNT_PROSPECTS: 'COUNT_PROSPECTS',
  ADD_CUSTOM_COLUMN: 'ADD_CUSTOM_COLUMN',
  CUSTOM_COLUMN: 'CUSTOM_COLUMN',
  WITH_A_CUSTOM_COLUMN: 'WITH_A_CUSTOM_COLUMN',
  CUSTOM_LIST_CUSTOM_COLUMN_POPOVER_TEXT_DEFAULT: 'CUSTOM_LIST_CUSTOM_COLUMN_POPOVER_TEXT_DEFAULT',
  CUSTOM_LIST_CUSTOM_COLUMN_POPOVER_TEXT_CATEGORY: 'CUSTOM_LIST_CUSTOM_COLUMN_POPOVER_TEXT_CATEGORY',
  CUSTOM_LIST_CUSTOM_COLUMN_CATEGORY_NAME_SHOULD_NOT_BE_EMPTY: 'CUSTOM_LIST_CUSTOM_COLUMN_CATEGORY_NAME_SHOULD_NOT_BE_EMPTY',
  CUSTOM_LIST_CUSTOM_COLUMN_CATEGORY_NAME_SHOULD_NOT_DUPLICATE: 'CUSTOM_LIST_CUSTOM_COLUMN_CATEGORY_NAME_SHOULD_NOT_DUPLICATE',
  CUSTOM_LIST_ADD_NEW_CATEGORY: 'CUSTOM_LIST_ADD_NEW_CATEGORY',
  CUSTOM_LIST_ADD_CUSTOM_COLUMNS: 'CUSTOM_LIST_ADD_CUSTOM_COLUMNS',
  CUSTOM_LIST_CUSTOM_COLUMN_DELETE_CATEGORY: 'CUSTOM_LIST_CUSTOM_COLUMN_DELETE_CATEGORY',
  CUSTOM_LIST_CUSTOM_COLUMN_DELETE_CATEGORY_TEXT: 'CUSTOM_LIST_CUSTOM_COLUMN_DELETE_CATEGORY_TEXT',
  CUSTOM_LIST_CUSTOM_COLUMN_NAME_SHOULD_NOT_BE_EMPTY: 'CUSTOM_LIST_CUSTOM_COLUMN_NAME_SHOULD_NOT_BE_EMPTY',
  CUSTOM_LIST_CUSTOM_COLUMN_NAME_SHOULD_NOT_DUPLICATE: 'CUSTOM_LIST_CUSTOM_COLUMN_NAME_SHOULD_NOT_DUPLICATE',
  CUSTOM_LIST_CUSTOM_COLUMN_POPOVER_TITLE: 'CUSTOM_LIST_CUSTOM_COLUMN_POPOVER_TITLE',
  CUSTOM_LIST_CUSTOM_COLUMN_YOU_HAVENOT_SAVED_CHANGES: 'CUSTOM_LIST_CUSTOM_COLUMN_YOU_HAVENOT_SAVED_CHANGES',
  CUSTOM_LIST_CUSTOM_COLUMN_DATA_TYPE_IS_REQUIRED: 'CUSTOM_LIST_CUSTOM_COLUMN_DATA_TYPE_IS_REQUIRED',
  CUSTOM_LIST_CUSTOM_COLUMN_COLUMN_NAME_ALREADY_EXISTS: 'CUSTOM_LIST_CUSTOM_COLUMN_COLUMN_NAME_ALREADY_EXISTS',
  COLUMN_NAME: 'COLUMN_NAME',
  DATA_TYPE: 'DATA_TYPE',
  FREE_TEXT: 'FREE_TEXT',
  AUTOCOMPLETE: 'AUTOCOMPLETE',
  ADD_TEXT_HERE: 'ADD_TEXT_HERE',
  ADD_TEXT: 'ADD_TEXT',
  EDIT_TEXT: 'EDIT_TEXT',
  DELETE_TEXT: 'DELETE_TEXT',
  CORPORATE_HISTORY: 'CORPORATE_HISTORY',
  REGISTERED_FOR: 'REGISTERED_FOR',
  UPDATED_WITH: 'UPDATED_WITH',
  ADDED: 'ADDED',
  NEW_ASSET: 'NEW_ASSET',
  NEW_ASSETS: 'NEW_ASSETS',
  ADD_ALL_PROSPECTS_TO_SHORTLIST: 'ADD_ALL_PROSPECTS_TO_SHORTLIST',
  SAVE_TO_CUSTOM_LIST: 'SAVE_TO_CUSTOM_LIST',
  CANT_ADD_MORE_THAN_MAXIMUM_PROSPECTS: 'CANT_ADD_MORE_THAN_MAXIMUM_PROSPECTS',
  ADD_ALL_PROSPECTS_TO_SHORTLIST_POPOVER_TITLE: 'ADD_ALL_PROSPECTS_TO_SHORTLIST_POPOVER_TITLE',
  ADD_ALL_PROSPECTS_TO_SHORTLIST_SUBTEXT: 'ADD_ALL_PROSPECTS_TO_SHORTLIST_SUBTEXT',
  ADD_ALL_PROSPECTS_TO_SHORTLIST_BUTTON_TOOLTIP: 'ADD_ALL_PROSPECTS_TO_SHORTLIST_BUTTON_TOOLTIP',
  ADD: 'ADD',
  PROSPECTS_ADDED_TO_SHORTLIST: 'PROSPECTS_ADDED_TO_SHORTLIST',
  PROSPECTS_ADDED_TO_SHORTLIST_SUBTEXT: 'PROSPECTS_ADDED_TO_SHORTLIST_SUBTEXT',
  SUCCESSFULLY_SAVED_PROSPECTS_TO_SEARCH_TITLE: 'SUCCESSFULLY_SAVED_PROSPECTS_TO_SEARCH_TITLE',
  SUCCESSFULLY_SAVED_ALL_PROSPECTS_TO_SEARCH_TITLE: 'SUCCESSFULLY_SAVED_ALL_PROSPECTS_TO_SEARCH_TITLE',
  SUCCESSFULLY_SAVED_PROSPECTS_TO_SEARCH_SUBTEXT: 'SUCCESSFULLY_SAVED_PROSPECTS_TO_SEARCH_SUBTEXT',
  FAILED_TO_SAVE_PROSPECTS_TO_SEARCH: 'FAILED_TO_SAVE_PROSPECTS_TO_SEARCH',
  AND: 'AND',
  OR: 'OR',
  CONTAINS: 'CONTAINS',
  EQUALS: 'EQUALS',
  IS_EMPTY: 'IS_EMPTY',
  IS_NOT_EMPTY: 'IS_NOT_EMPTY',
  CUSTOM_LIST_FILTER_SHORTLIST: 'CUSTOM_LIST_FILTER_SHORTLIST',
  CUSTOM_LIST_FILTER_SHORTLIST_POPOVER_TEXT: 'CUSTOM_LIST_FILTER_SHORTLIST_POPOVER_TEXT',
  CUSTOM_LIST_FILTER_SHORTLIST_ADD_FILTER_BTN: 'CUSTOM_LIST_FILTER_SHORTLIST_ADD_FILTER_BTN',
  CUSTOM_LIST_FILTER_SHORTLIST_REMOVE_ALL_BTN: 'CUSTOM_LIST_FILTER_SHORTLIST_REMOVE_ALL_BTN',
  CUSTOM_LIST_FILTER_SHORTLIST_COLUMN: 'CUSTOM_LIST_FILTER_SHORTLIST_COLUMN',
  CUSTOM_LIST_FILTER_SHORTLIST_OPERATOR: 'CUSTOM_LIST_FILTER_SHORTLIST_OPERATOR',
  CUSTOM_LIST_FILTER_SHORTLIST_VALUE: 'CUSTOM_LIST_FILTER_SHORTLIST_VALUE',
  CUSTOM_LIST_FILTER_SHORTLIST_BTN: 'CUSTOM_LIST_FILTER_SHORTLIST_BTN',
  CUSTOM_LIST_FILTER_LOGIC_COMBINATION: 'CUSTOM_LIST_FILTER_LOGIC_COMBINATION',
  CUSTOM_LIST_FILTER_APPLIED: 'CUSTOM_LIST_FILTER_APPLIED',
  CHANGED: 'CHANGED',
  UNDO: 'UNDO',
  SUCCESSFULLY_UNDO_SAVE_PROSPECTS_TO_SEARCH_TITLE: 'SUCCESSFULLY_UNDO_SAVE_PROSPECTS_TO_SEARCH_TITLE',
  FAILED_TO_UNDO_SAVE_PROSPECTS_TO_SEARCH_TITLE: 'FAILED_TO_UNDO_SAVE_PROSPECTS_TO_SEARCH_TITLE',
  BETWEEN: 'BETWEEN',
  START: 'START',
  END: 'END',
  NO_FILTER_APPLIED: 'NO_FILTER_APPLIED',
  MULTIPLE_EVENTS_FILTERED: 'MULTIPLE_EVENTS_FILTERED',
  DELEGATE: 'DELEGATE',
  DELEGATES: 'DELEGATES',
  PROFILES_FILTER_TITLE: 'PROFILES_FILTER_TITLE',
}

export default translations
